import { gql } from '@apollo/client';

export const GET_CATALOGS = gql`
  query catalogs(
    $catalogsInput: CatalogsInput!
    $itemsInput: CatalogItemsInput!
    $count: Int
  ) {
    catalogs(input: $catalogsInput, count: $count) {
      id
      eligibleDeliveryDates
      items(input: $itemsInput) {
        id
        priceInCents
        recommenderScore
        oneTimeOrderPriceInCents
        soldOut
        variant {
          __typename
          id
          product {
            id
            sku {
              sku
              review {
                rating
              }
            }
            imageUrl
            name
            title
            subtitle
            gardenMealId
            designer {
              name
            }
            description
          }
          tags {
            ...tagFields
          }
          mealTypeTags: tags(categoryName: "meal_type") {
            ...tagFields
          }
          dietaryTemplateTags: tags(categoryName: "dietary_template") {
            ...tagFields
          }
          flavorProfileTags: tags(categoryName: "flavor_profile") {
            ...tagFields
          }
          spicyTags: tags(categoryName: "flavor_profile", value: "spicy") {
            ...tagFields
          }
          servingsTags: tags(categoryName: "servings") {
            ...tagFields
          }
          promotionalTags: tags(categoryName: "promotional") {
            ...tagFields
          }
          celebrityChefTags: tags(
            categoryName: "promotional"
            value: "celebrity chef"
          ) {
            ...tagFields
          }
          seasonalTags: tags(categoryName: "status", value: "seasonal") {
            ...tagFields
          }
          territoryServesTags: tags(
            categoryName: "promotional"
            value: "TerritoryServes"
          ) {
            ...tagFields
          }
          newTags: tags(categoryName: "status", value: "new") {
            ...tagFields
          }
          improvedRecipeTags: tags(
            categoryName: "status"
            value: "Improved Recipe"
          ) {
            ...tagFields
          }
          statusTags: tags(categoryName: "status") {
            ...tagFields
          }
          ... on MealVariant {
            size
            containsAllergensCopy
            nutritionCaveat
            ingredientsToAvoid {
              displayName
              isAllergen
              legacyAllergenItemId
              category {
                legacyAllergenCategoryId
                displayName
              }
            }
            publicIngredientsCopy
            macroNutrients {
              caloriesInG
              calories
              cholesterolInMg
              dietaryFiberInG
              netCarbsInG
              proteinInG
              saturatedFatInG
              servingSizeInOz
              sodiumInMg
              sugarsInG
              totalCarbsInG
              totalFatInG
              addedSugarInG
              vitaminDInMcg
              calciumInMg
              ironInMg
              potassiumInMg
            }
          }
        }
      }
    }
  }

  fragment tagFields on Tag {
    id
    displayValue
    displayName
    value
    category {
      apiName
      id
      name
    }
  }
`;

export const GET_INGREDIENTS_TO_AVOID = gql`
  query ingredientsToAvoid {
    ingredientsToAvoid {
      legacyAllergenItemId
      displayName
      isAllergen
      category {
        legacyAllergenCategoryId
        displayName
      }
    }
  }
`;

export const GET_VARIANTS = gql`
  query variants($variantsInput: VariantsInput!) {
    variants(input: $variantsInput) {
      id
      product {
        id
        imageUrl
        name
        title
        subtitle
        designer {
          name
        }
        description
      }
      tags {
        id
        displayValue
        displayName
        value
        category {
          id
          name
        }
      }
      ... on MealVariant {
        size
        containsAllergensCopy
        nutritionCaveat
        ingredientsToAvoid {
          displayName
          isAllergen
          legacyAllergenItemId
          category {
            legacyAllergenCategoryId
            displayName
          }
        }
        publicIngredientsCopy
        macroNutrients {
          caloriesInG
          calories
          cholesterolInMg
          dietaryFiberInG
          netCarbsInG
          proteinInG
          saturatedFatInG
          servingSizeInOz
          sodiumInMg
          sugarsInG
          totalCarbsInG
          totalFatInG
          addedSugarInG
          vitaminDInMcg
          calciumInMg
          ironInMg
          potassiumInMg
        }
      }
    }
  }
`;
